export enum AgenciesRoutes {
  AgenciesList = 'agencies-list',
  AgencyManagement = 'agency-management',
  AgencyHierarchyAdministration = 'agency-hierarchy-administration',
}
